<template>
  <div class='cm-guild-search-field'>
    <div class='cm-guild-search-field__input-wrapper'>
      <label
        class='cm-guild-search-field__placeholder'
        :class='{
          "cm-guild-search-field__placeholder--visible": value === "",
        }'
        for='cm-guild-search-field__input'
      >
        Search <component :is='resultCount ? "strong" : "span"'>{{ placeholderLabel }}</component> by keyword
      </label>

      <input
        :value='value'
        @input='$emit("input", $event.target.value)'
        ref='input'
        id='cm-guild-search-field__input'
        class='cm-guild-search-field__input'
        autocomplete="off"
      />

      <div
        class='cm-guild-search-field__icon'
      >🔎</div>
    </div>
  </div>
</template>

<script>
import { formatNumber } from "../lib/number";

export default {
  props: {
    value: {
      type: String
    },
    resultCount: {
      type: Number,
      required: true
    },
    unitLabels: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      isFocused: false
    };
  },

  computed: {
    placeholderLabel() {
      const unit =
        this.resultCount === 1
          ? this.unitLabels.singular
          : this.unitLabels.plural;

      if (this.resultCount) {
        return `${formatNumber(this.resultCount)} ${unit}`;
      } else {
        return unit;
      }
    }
  },

  methods: {
    formatNumber,

    handleFocus() {
      this.isFocused = true;
    },

    handleBlur(event) {
      if (event.relatedTarget === null) return;
      if (document.activeElement === null) return;

      const focusedOutside = !this.$el.contains(event.relatedTarget);

      if (focusedOutside) {
        this.isFocused = false;
      }
    }
  }
};
</script>

<style lang='scss'>
.cm-guild-search-field {
  position: relative;
  background: var(--bg-2);
  width: 100%;
  border: 0 none;
  border-radius: var(--radius-large);
  margin: 1rem 0;

  &__input,
  &__placeholder {
    @extend %h5;
    font-weight: unset;
    padding: 0 4rem 0 1rem;
    line-height: 3.5rem;
    height: 3.5rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  &__input {
    position: relative;
    background: none;
    border: none;
    width: 100%;
    appearance: none;
    color: var(--fg);
    &:focus {
      outline: none;
    }
  }
  &__placeholder {
    position: absolute;
    width: 100%;
    color: var(--fg-2);
    opacity: 0;
    &--visible {
      opacity: 1;
    }
  }
  &__icon {
    font-family: $ff_icon;
    position: absolute;
    height: 100%;
    display: flex;
    align-items: center;
    top: 0;
    right: 0;
    padding: 0.2rem 1.2rem 0;
    color: var(--fg-2);
    pointer-events: none;
  }
}
</style>



// WEBPACK FOOTER //
// app/javascript/components/guild-search.vue?22777966